import Cookie from "./cookie";
import Commons from "./common";

const SNSLogin = (function() {
    function getParameters(paramName, isNaver = false) {
            // 리턴값을 위한 변수 선언
            var returnValue;
        
            // 현재 URL 가져오기
            var url = "";
            if(isNaver) {
                url = opener.location.href;
            } else {
                url = location.href;
            }
        
        // get 파라미터 값을 가져올 수 있는 ? 를 기점으로 slice 한 후 split 으로 나눔
        var parameters = (url.slice(url.indexOf('?') + 1, url.length)).split('&');
    
        // 나누어진 값의 비교를 통해 paramName 으로 요청된 데이터의 값만 return
        for (var i = 0; i < parameters.length; i++) {
            var varName = parameters[i].split('=')[0];
            if (varName.toUpperCase() == paramName.toUpperCase()) {
                returnValue = parameters[i].split('=')[1];
                return returnValue;
            }
        }
    };

    const MESSAGE_DEL_USER = "탈퇴한 회원입니다.";

    let loginMode = "login"; // login : join

    const NAVER_APP_KEY = "ypg81nNzuD6MqAkMelo8";
    const KAKAO_APP_KEY = "ebb38bd86dfcc1dd6e5e673a11a99764";
    const FACEBOOK_APP_KEY = "238240426379052";

    function init(mode = "login") {
        // 네이버 초기화
        NaverLogin.init();
        // 카카오 초기화
        Kakao.init(KAKAO_APP_KEY);
        // Facebook 초기화
        FacebookLogin();

        $("#kakao_login_btn").on("click", loginWithKakao);
        $("#naver_login_btn").on("click", loginWithNaver);
        $("#facebook_login_btn").on("click", loginWithFacebook);

        loginMode = mode;
        console.log(loginMode);
    }

    function loginWithNaver(e) {
        e.preventDefault();
        var naverLoginBtnReal = document.getElementById(
            "naverIdLogin_loginButton"
        );
        naverLoginBtnReal.href = "javascript:void(0)";
        if (/*@cc_on ! @*/ false) {
            // IE
            naverLoginBtnReal.click();
        } else {
            // Others
            var event = document.createEvent("MouseEvents");
            event.initEvent("click", false, true);
            naverLoginBtnReal.dispatchEvent(event);
        }
    }

    function loginWithKakao(e) {
        // 로그인 창을 띄웁니다.
        Kakao.Auth.loginForm({
            success: function(authObj) {
                $.ajax("//www.waglebagle.net/member/_proc/kakao_api.php", {
                    type: "POST",
                    data: { accessToken: authObj.access_token }
                })
                    .then(function(res) {
                        // 카카오 프로필 정보를 조회한다.
                        res = JSON.parse(res);
                        return createSNSObj(
                            "kakao",
                            res["id"],
                            "K",
                            "",
                            res.properties["nickname"],
                            res["kaccount_email"],
                            "",
                            authObj.access_token
                        );
                    })
                    .then(loginProcess);
            },
            fail: function(err) {
                console.log(err);
                alert(JSON.stringify(err));
            }
        });
    }

    // 네이버
    var NaverLogin = new naver.LoginWithNaverId({
        clientId: NAVER_APP_KEY,
        callbackUrl:
            (location.origin ? location.origin : "http://" + location.host) +
            "/member/naver_callback.php",
        isPopup: true /* 팝업을 통한 연동처리 여부 */,
        loginButton: {
            color: "green",
            type: 3,
            height: 60
        } /* 로그인 버튼의 타입을 지정 */
    });

    function FacebookLogin() {
        window.fbAsyncInit = function() {
            FB.init({
                appId: FACEBOOK_APP_KEY,
                status: true,
                cookie: true,
                xfbml: true,
                oauth: true
            });
        };

        (function(d) {
            var js,
                id = "facebook-jssdk",
                ref = d.getElementsByTagName("script")[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement("script");
            js.id = id;
            js.async = true;
            js.src = "//connect.facebook.net/ko_KR/all.js";
            ref.parentNode.insertBefore(js, ref);
        })(document);
    }

    function loginWithFacebook(e) {
        e.preventDefault();

        FB.login(
            function(response) {
                if (response.authResponse && response.status == "connected") {
                    var accessToken = response.authResponse.accessToken;

                    FB.api("/me/permissions", function(res) {
                        let isGrantedAll = true;
                        res.data.forEach(function(v) {
                            if (
                                v.permission === "email" &&
                                v.status !== "granted"
                            ) {
                                alert(
                                    "가입시 이메일 정보는 필수입니다. \n이메일 정보를 허용하여 주시기 바랍니다."
                                );
                                FB.login(
                                    function(response) {
                                        // console.log(response);
                                    },
                                    {
                                        scope: "email",
                                        auth_type: "rerequest"
                                    }
                                );
                                isGrantedAll = false;
                                return;
                            }
                        });
                        if (isGrantedAll) {
                            FB.api(
                                "/me",
                                {
                                    fields: "email, name"
                                },
                                function(user) {
                                    let user_id = user.id;
                                    if (user_id) {
                                        var snsObj = createSNSObj(
                                            "facebook",
                                            user_id,
                                            "F",
                                            user.name,
                                            "",
                                            user.email,
                                            "",
                                            accessToken
                                        );

                                        loginProcess(snsObj);
                                    }
                                }
                            );
                        }
                    });
                } else {
                    return false;
                }
            },
            {
                scope: "public_profile, email"
            },
            function() {}
        );
    }

    // 한달 이내인지 체크
    function isWithinOneMonth(dateStr) {
        const slicedDate = dateStr.slice(0, 10); // 2018-03-09 00:00:00 에서 시분초 제거

        const priorOneMonth = Date.now() - 1000 * 60 * 60 * 24 * 31; // 한달 전
        const theDate = new Date(slicedDate).getTime();

        return priorOneMonth < theDate ? true : false;
    }

    function loginProcess(snsObj, mode = null) {
        if (mode !== null) {
            loginMode = mode;
        }

        // 해당 계정으로 가입되었는지 조회한다.
        $.ajax("//www.waglebagle.net/member/_proc/sns_check.php", {
            type: "POST",
            data: snsObj
        }).then(function(res) {
            localStorage.removeItem("snsObj");
            // Cookie.deleteCookie("snsObj");

            try {
                res = JSON.parse(res);
            } catch (e) {
                console.log(e);
                console.log(res);
            }

            if (res["joined"]) {
                if (
                    // 내가 회원가입이 되어있어
                    // 회원정보가 있는데 // 회원탈퇴상태 // 1개월 이내
                    res.member &&
                    res.member.status === "D" &&
                    isWithinOneMonth(res.member.update_date)
                ) {
                    if (loginMode === "login") {
                        if (snsObj["mode"] === "naver") {
                            if (
                                opener.location.href
                                    .split("/")
                                    .pop()
                                    .replace("#", "") == "login.htm"
                            ) {
                                opener.alert("회원 정보가 없습니다.");
                                opener.location.replace(
                                    "//www.waglebagle.net/member/join_home.html"
                                );
                                window.close();
                                return;
                            }
                        } else {
                            if (
                                location.href
                                    .split("/")
                                    .pop()
                                    .replace("#", "") == "login.htm"
                            ) {
                                alert("회원 정보가 없습니다.");
                                location.href =
                                    "//www.waglebagle.net/member/join_home.html";
                                return;
                            }
                        }
                    }
                    checkRejoin(snsObj).then(response => {
                        var result = JSON.parse(response);
                        if (result.success === true) {
                            // 재가입한 상태면
                            snsObj.rejoin = true;
                        } else {
                            snsObj.rejoin = false;
                        }
                        deleteMe(res.member.sns_id).then(() => {
                            doJoin(snsObj);
                        });
                    });
                    return;
                } else {
                    if (loginMode === "login") {
                        doLogin(
                            res.member,
                            snsObj.oauth_token,
                            snsObj.mode,
                            false
                        );
                    } else {
                        alert("이미 가입된 계정입니다.");
                        if (snsObj["mode"] === "naver") {
                            opener.location.replace(
                                "//www.waglebagle.net/member/login.htm"
                            );
                            window.close();
                            return;
                        } else {
                            location.href =
                                "//www.waglebagle.net/member/login.htm";
                            return;
                        }
                    }
                }
            } else if (res["duplicatedEmail"]) {
                // 회원가입을 한게 아닌데 중복 이메일이 있을 경우
                let snsTxt = null;
                switch (res.whois.join_site) {
                    case "N":
                        snsTxt = "네이버";
                        break;
                    case "K":
                        snsTxt = "카카오";
                        break;
                    case "F":
                        snsTxt = "페이스북";
                        break;
                    default:
                        break;
                }

                let message = null;
                // 내가 와글바글 회원가입이 되어있어
                // 회원정보가 있는데 // 회원탈퇴상태 // 1개월 이내
                if (res["whois"]["status"] == "D") {
                    if (loginMode === "login") {
                        if (snsObj["mode"] === "naver") {
                            if (
                                opener.location.href
                                    .split("/")
                                    .pop()
                                    .replace("#", "") == "login.htm"
                            ) {
                                opener.alert("회원 정보가 없습니다.");
                                opener.location.replace(
                                    "//www.waglebagle.net/member/join_home.html"
                                );
                                window.close();
                                return;
                            }
                        } else {
                            if (
                                location.href
                                    .split("/")
                                    .pop()
                                    .replace("#", "") == "login.htm"
                            ) {
                                alert("회원 정보가 없습니다.");
                                location.href =
                                    "//www.waglebagle.net/member/join_home.html";
                                return;
                            }
                        }
                    }
                    if (
                        isWithinOneMonth(res.whois.update_date) &&
                        res.whois.join_site == "W"
                    ) {
                        snsObj.rejoin = true;
                        deleteMeWaglebagle(res.whois.user_id);
                        doJoin(snsObj);
                        return;
                    }
                    checkRejoin(snsObj).then(res => {
                        var result = JSON.parse(res);
                        if (result.success === true) {
                            // 재가입한 상태면
                            snsObj.rejoin = true;
                        } else {
                            snsObj.rejoin = false;
                        }
                        doJoin(snsObj);
                    });
                    return;
                } else {
                    message = `동일 이메일로 가입된 ${snsTxt} 계정이 있습니다.`;
                }

                switch (res.whois.join_site) {
                    case "N":
                    case "K":
                    case "F":
                        notifyDuplicatedEmail({
                            snsMode: snsObj["mode"],
                            message: message
                        });
                        break;
                    case "W":
                        let userId = res.whois.user_id;
                        let hiddenId =
                            userId.slice(0, 3) + "*".repeat(userId.length - 3);

                        if (loginMode === "login") {
                            notifyDuplicatedEmail({
                                snsMode: snsObj["mode"],
                                message: `이미 가입된 계정입니다. \n와글바글 아이디: ${hiddenId}`
                            });
                        } else {
                            notifyDuplicatedEmail({
                                snsMode: snsObj["mode"],
                                message:
                                    "동일한 이메일로 가입되어 있습니다. 아이디/비밀번호 찾기를 이용해주세요."
                            });
                        }
                        break;
                    // no default
                }
                return;
            } else {
                // 아니라면
                // 회원가입 약관동의 페이지로
                if (loginMode === "login") {
                    if (snsObj["mode"] === "naver") {
                        if (
                            opener.location.href
                                .split("/")
                                .pop()
                                .replace("#", "") == "login.htm"
                        ) {
                            opener.alert("회원 정보가 없습니다.");
                            opener.location.replace(
                                "//www.waglebagle.net/member/join_home.html"
                            );
                            window.close();
                            return;
                        }
                    } else {
                        if (
                            location.href
                                .split("/")
                                .pop()
                                .replace("#", "") == "login.htm"
                        ) {
                            alert("회원 정보가 없습니다.");
                            location.href =
                                "//www.waglebagle.net/member/join_home.html";
                            return;
                        }
                    }
                }
                checkRejoin(snsObj).then(res => {
                    var result = JSON.parse(res);
                    if (result.success === true) {
                        // 재가입한 상태면
                        snsObj.rejoin = true;
                    } else {
                        snsObj.rejoin = false;
                    }
                    doJoin(snsObj);
                });
            }
        });
    }

    function isLoginModeThenCallback(loginMode, callback) {
        if (loginMode === "login") {
            return callback;
        }
    }

    function goJoinHome(snsObj) {
        if (snsObj["mode"] === "naver") {
            if (
                opener.location.href
                    .split("/")
                    .pop()
                    .replace("#", "") == "login.htm"
            ) {
                opener.location.replace(
                    "//www.waglebagle.net/member/join_home.html"
                );
                window.close();
                return;
            }
        } else {
            if (
                location.href
                    .split("/")
                    .pop()
                    .replace("#", "") == "login.htm"
            ) {
                location.href = "//www.waglebagle.net/member/join_home.html";
                return;
            }
        }
    }

    function deleteMeWaglebagle(wgbgId) {
        return $.ajax("./_proc/sns_common.php", {
            type: "POST",
            data: {
                mode: "delete_by_wgbgid",
                wgbg_id: wgbgId
            }
        });
    }

    function deleteMe(snsId) {
        return $.ajax("./_proc/sns_common.php", {
            type: "POST",
            data: {
                mode: "delete_by_snsid",
                sns_id: snsId
            }
        });
    }

    function checkRejoin(snsObj) {
        return $.ajax("./_proc/sns_common.php", {
            type: "POST",
            data: {
                mode: "check_rejoin",
                user_email: snsObj.user_email,
                user_id: snsObj.user_id
            }
        });
    }

    function doJoin(snsObj) {
        // 아니라면
        // 회원가입 약관동의 페이지로
        var winOp;
        var tid;

        fullmap(snsObj);
    }

    function fullmap(snsObj) {
        var openUrl = "./join_provision.htm?snsType=" + snsObj["mode"];

        localStorage.setItem(
            "snsObj",
            encodeURIComponent(JSON.stringify(snsObj))
        );

        if (snsObj["mode"] === "naver") {
            opener.location.replace(openUrl);
            window.close();
        } else {
            winOp = window.open(openUrl, "_self");
        }
    }

    function doLogin(member, oauth_token, sns_mode, isRejoin = false) {
        // 이미 회원가입 된 계정이면 로그인
        $.ajax("//www.waglebagle.net/member/_proc/sns_login.php", {
            type: "POST",
            data: {
                member: member,
                oauth_token: oauth_token,
                rejoin: isRejoin
            }
        }).then(res => {
            if (sns_mode === "naver") {
                if (/^join+/.test(document.referrer.split("/").pop())) {
                    opener.location.href = opener.location.href =
                        "//www.waglebagle.net";
                    return;
                }
                var reUrl = getParameters("reUrl", true);
                // alert(reUrl);
                if(reUrl) {
                    opener.location.href = "//www.waglebagle.net" + decodeURIComponent(atob(reUrl));
                } else if(opener.document.referrer && (opener.document.referrer.indexOf("waglebagle.net") !== -1)){
                    opener.history.back();
                } else {
                    opener.location.href = "//www.waglebagle.net";
                }

                // opener.document.referrer &&
                // -1 != opener.document.referrer.indexOf("waglebagle.net")
                //     ? opener.history.back()
                //     : (opener.location.href = "//www.waglebagle.net");
                // opener.location.replace("/");
                window.close();
            } else {
                if (/^join+/.test(document.referrer.split("/").pop())) {
                    location.href = location.href = "//www.waglebagle.net";
                    return;
                }
                var reUrl = getParameters("reUrl");
                if(reUrl) {
                    location.href = "//www.waglebagle.net" + decodeURIComponent(atob(reUrl));
                } else if(document.referrer && (document.referrer.indexOf("waglebagle.net") !== -1)){
                    history.back();
                } else {
                    location.href = "//www.waglebagle.net";
                }
            }
        });
    }

    function notifyDuplicatedEmail({ snsMode, message }) {
        if (snsMode === "naver") {
            opener.alert(message);
            window.close();
        } else {
            alert(message);
        }
    }

    function createSNSObj(
        mode,
        userId,
        snsFlag,
        realName,
        nickName,
        email,
        birthday,
        accessToken
    ) {
        var snsObj = {};
        snsObj["mode"] = mode ? mode : ""; // facebook, naver, kakao
        snsObj["sns_id"] = userId ? userId : ""; // 고유 ID
        snsObj["sns_flag"] = snsFlag ? snsFlag : ""; // F (facebook), N (naver), K (kakao)
        snsObj["realname"] = realName ? realName : ""; // 실명
        snsObj["nickname"] = nickName ? nickName : ""; // 별명
        snsObj["user_email"] = email ? email : ""; // 이메일
        snsObj["birthday"] = birthday ? birthday : ""; // 생년월일
        snsObj["oauth_token"] = accessToken ? accessToken : ""; // 접속 토큰
        snsObj["rand"] = Math.floor(Math.random() * 10000);
        snsObj["confiremd_eula"] = "N";
        snsObj["rejoin"] = false;

        return snsObj;
    }

    return {
        init: init,
        createSNSObj: createSNSObj,
        loginProcess: loginProcess
    };
})();

export default SNSLogin;



// WEBPACK FOOTER //
// ./member/js/snslogin.js